__turbopack_context__.v({
  "link": "Alt-module__SSG4lW__link",
  "linkIcon": "Alt-module__SSG4lW__linkIcon",
  "navbar": "Alt-module__SSG4lW__navbar",
  "navbarMain": "Alt-module__SSG4lW__navbarMain",
  "title": "Alt-module__SSG4lW__title",
});
